var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.167 0.833496C17.067 0.833496 11.2169 3.2567 6.90354 7.57004C2.5902 11.8834 0.166992 17.7335 0.166992 23.8335C0.166992 29.9335 2.5902 35.7836 6.90354 40.097C11.2169 44.4103 17.067 46.8335 23.167 46.8335C29.267 46.8335 35.1171 44.4103 39.4304 40.097C43.7438 35.7836 46.167 29.9335 46.167 23.8335C46.167 17.7335 43.7438 11.8834 39.4304 7.57004C35.1171 3.2567 29.267 0.833496 23.167 0.833496Z",
    fill: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2816 29.9298H32.2337L33.1683 23.8832H26.2804V20.5784C26.2804 18.0666 27.1011 15.8392 29.4507 15.8392H33.2264V10.5625C32.563 10.473 31.16 10.2769 28.509 10.2769C22.9732 10.2769 19.7278 13.2003 19.7278 19.8606V23.8832H14.0371V29.9298H19.7278V46.5491C20.8548 46.7185 21.9963 46.8335 23.1681 46.8335C24.2273 46.8335 25.2611 46.7367 26.2816 46.5987V29.9298Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.9c3be9a0f540dda3f81a0779e3a38709.svg";
export { ForwardRef as ReactComponent };